import { useInboxesStore } from 'store/modules';

const state = () => ({
    _count: 0,
});

const getters = {
    unreadCount: (state) => state._count,
};

const actions = {
    async setUnreadCount(inbox) {
        const unread = await useInboxesStore().inboxUpdateCount(inbox);

        this._setUnreadCountSet(unread);
    },

    _setInboxesLoaded({ inboxes }) {
        let count = 0;

        inboxes.forEach((item) => {
            if (item.id === 0) return;

            count += item.unread;
        });

        this._count = count;
    },

    _setUnreadCountSet(unread) {
        this._count = unread;
    },
};

export default {
    state,
    getters,
    actions,
};
